import { initializeApollo } from 'lib/apolloClient';
import { getGlobalData } from 'lib/global.js';
import { GetStaticPropsContext } from 'next';
import { Banner, Category, PageInfo, Post } from 'generated-graphql';
import appConfig from '@/app.config';
import { CATEGORIES } from 'gql/categories';
import { get } from 'lodash';
import { getPosts } from 'gql/posts';
import React from 'react';
import ResourcesPage from '@/components/ResourcesPage/ResourcesPage';
import { BANNERS } from 'gql/banners';

const ResourceCategory = ({
  pageData,
  categories,
  c,
  pageInfo,
  banners,
  featured
}: {
  pageData: Post[];
  categories: Category[];
  c: Category;
  pageInfo: PageInfo,
  banners: Banner[] | [];
  featured: Post[];
}) => {

  return (
    <ResourcesPage banners={banners} pageData={pageData} categories={categories} c={c} pageInfo={pageInfo} featured={featured} />
  );
};

export default ResourceCategory;

export async function getStaticPaths() {
  const apolloClient = initializeApollo();
  const categoriesQuery = await apolloClient.query({
    query: CATEGORIES,
    variables: { names: ['What we do', 'Series'] },
  });

  const data: Category[] = [];

  const categories = get(categoriesQuery, 'data.categories.nodes', []) as Category[];
  categories.forEach((mainCat) => {
    mainCat.children?.nodes.forEach((cat) => {
      data.push(cat);
    })
  });

  return {
    paths: data.map((node: Category) => `/resources/c/${node.slug}`) || [],
    fallback: 'blocking',
  };
}

export async function getStaticProps(context: GetStaticPropsContext) {
  const { params } = context;
  const apolloClient = initializeApollo();

  const v = params?.slug;

  const categoriesQuery = await apolloClient.query({
    query: CATEGORIES,
    variables: { names: ['What we do', 'Series'] },
  });

  const categories = get(categoriesQuery, 'data.categories.nodes', []) as Category[];

  const categoryLabels: string[] = [];

  let c: any = null;
  categories.forEach((mainCat) => {
    mainCat.children?.nodes.forEach((cat) => {
      if (cat.slug === v) {
        c = cat;
        categoryLabels.push(cat.name || '');
      }
    })
  });



  const series = ['Agents of Change', 'Unboxed'];
  let banners;

  if (series.includes(String(c?.name))) {
    banners = await apolloClient.query({
      query: BANNERS,
    });
  }

  const results = await apolloClient.query({
    query: getPosts(
      categoryLabels,
    ), variables: {
      first: 11,
    }
  });

  const featured = await apolloClient.query({
    query: getPosts(
      ["Featured", ...categoryLabels]
    ), variables: {
      first: 3,
    }
  });


  const pageProps = {
    pageInfo: results.data?.posts?.pageInfo,
    pageData: results.data?.posts?.nodes || [],
    featured: featured.data?.posts?.nodes || [],
    categories,
    c,
    banners: banners?.data.banners.nodes.filter((b: Banner) => b.banner?.category?.name === c?.name) || [],
  };

  return await getGlobalData(pageProps, apolloClient, {
    revalidate: appConfig.revalidate,
  });
}
